export const ONBOARDING = {
  MEMBER_DASHBOARD: 1,
};

export const MAX_NOTE_CHARACTER_COUNT = 32;
